import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Spinner, Container, Button, Alert, Modal} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useContract } from '../contexts/ContractContext';
import { useEffect, useState } from 'react';
import { formatDate } from '../Utils/formatDate';
import {useAuth} from "../contexts/AuthenticationContext";
import {api} from "../services/Api";

export function Menu(){
	const { session } = useAuth();

	const { contracts, openInvoice, contractSelected, loadingContracts, connections, handleSetModalContractShow, handleLoad } = useContract();

	const [connectionHeader, setConnectionHeader] = useState("card-header-info")
	const [contractHeader, setContractHeader] = useState("card-header-info")
	const [invoiceHeader, setInvoiceHeader] = useState("card-header-info")
	const [unblockResponse, setUnblockResponse] = useState<String>('');
	const [unblockResponseStatus, setUnblockResponseStatus] = useState<boolean | null>(true);
	const [unblockResponseReload, setUnblockResponseReload] = useState<boolean | null>(false);
	const [showModalUnblock, setShowModalUnblock] = useState(false);
	const [loadingModalUnblock, setLoadingModalUnblock] = useState(false);

	useEffect(() => {
		if (!session?.id_contract) {
			handleLoad();
		}
	}, [session, handleLoad])

	useEffect(() => {

		if(contractSelected?.status === "Em digitação" || contractSelected?.status === "Pré Contrato" || contractSelected?.status === "Inativo" || contractSelected?.status === "Bloqueado" || contractSelected?.status === "Bloqueado Parcialmente" || contractSelected?.status === "Encerrado" || contractSelected?.status === "Excluido") {
			setContractHeader("card-header-warning");
		}

		if(openInvoice?.status_mais_antiga === 'vencido') {
			setInvoiceHeader("card-header-danger");
		}

		connections?.forEach(element => {
			if(element.status === 'Conexão Bloqueada' || element.status === 'Conexão Removida' || element.status === 'Conexão Excluida') {
				setConnectionHeader("card-header-warning")
			}
		});
	}, [contractSelected, connections, openInvoice?.status_mais_antiga])

	function handleContractUnblock() {
		if(session){
			setLoadingModalUnblock(true);

			const headers = {
				'Authorization': 'Beaser '+session.token,
				'Content-Type': 'application/json',
			};

			api.get('v1/pessoas/clientes/contratos/'+session.id_contract, { headers })
				.then((response: any) => {
					api.post('v1/pessoas/clientes/desbloqueio-temporario', JSON.stringify({id: response.data.id}), { headers })
						.then((response: any) => {
							setUnblockResponse(response.data.message);
							setUnblockResponseStatus(true);
							setLoadingModalUnblock(false);
							setUnblockResponseReload(true);
						})
						.catch(error => {
							setUnblockResponse(error.response.data.message);
							setUnblockResponseStatus(false);
							setLoadingModalUnblock(false);
							setUnblockResponseReload(false);
						});
				})
				.catch(error => {
					setUnblockResponse(error.response.data.message);
					setUnblockResponseStatus(false);
					setLoadingModalUnblock(false);
					setUnblockResponseReload(false);
				});
		}
	}

	function handleActivateStreaming(streaming: { id_contrato_servico: number | null; id_contrato_servico_produto: number | null; nome: string; servicos: []; }) {
		if (session) {
			let servicos_adicionar = [];
			for (let i = 0; i < streaming.servicos.length; i++) {
				let aux: any = {};
				aux.id_contrato_servico = streaming.id_contrato_servico;
				aux.id_contrato_servico_produto = streaming.id_contrato_servico_produto;
				aux.servico = streaming.servicos[i];
				servicos_adicionar.push(aux);
			}

			let token_body = JSON.stringify({
				token: session.token,
				servicos_adicionar: servicos_adicionar,
				servicos_remover: [],
				servicos_migrar: [],
			});

			let token = btoa(token_body);

			window.open("https://cliente.netcomet.com.br/ativacao-streaming/"+token, "_blank");
		}
	}

	return(
		<>
			<Header/>
			<Container>
				<Row className="m-3">
					<Col md={4} sm={4} className="d-flex w-25 p-0">
						<h4 className="title-page d-flex">
							<span className="material-icons title-icon">home</span>
							Menu
						</h4>
					</Col>
					<Col md={8} sm={8} className="d-flex justify-content-end text w-75 p-0">
						<Button className="d-flex justify-content-center align-items-center" size={"sm"} variant="light" onClick={() => {if(contracts && contracts?.length > 1) {handleSetModalContractShow(true)}}}>
							<span className="material-icons title-icon">menu_book</span>
							CONTRATO {session?.numero_contrato ? `${session?.numero_contrato}` : ''}
							{contracts && contracts?.length > 1 && <span className="material-icons title-icon me-0 ms-0">keyboard_arrow_down</span>}
						</Button>
					</Col>
				</Row>
				{openInvoice?.alertContracts && <Row className="m-3">
					<Alert variant={"warning"} className="d-flex justify-content-center align-items-center">
						<span className="material-icons title-icon">error</span>
						Você tem pendências em seus outros contratos
					</Alert>
				</Row>}
				{contractSelected && !loadingContracts && contractSelected.status !== 'Ativo' && contractSelected.status !== 'Ativo - Temporário' && contractSelected.desbloqueio === '1' && <Row className="m-3">
					<Alert variant={"warning"} className="justify-content-center align-items-center">
						<div className="d-flex justify-content-center align-items-center">
							<span className="material-icons title-icon">error</span>
							Seu contrato está bloqueado
						</div>
			  		<div className="d-flex justify-content-center align-items-center mt-2">
							<Button variant="primary" onClick={() => {setShowModalUnblock(true)}}>Informar Pagamento e Desbloquear</Button>
						</div>
					</Alert>
				</Row>}
				<Row>
					{((contractSelected?.streamings?.length !== undefined && contractSelected?.streamings?.length > 0) || contractSelected?.playhub) && (<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">tv</span>
										Streaming
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingContracts && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!loadingContracts && contractSelected?.streamings?.map((streaming, idx) => ( <div key={idx}>
											{idx >= 1 && <Row>
												<Col md={12} sm={12} xs={12}>
													<hr/>
												</Col>
											</Row>}
											<Row>
												<Col md={8} sm={8} xs={8}>
													<p className="mb-1"><b>{streaming.nome}</b></p>
													<p className="color-gray">Clique em executar para ativar o seu serviço de streaming</p>
												</Col>
												<Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
													<Button variant="light" onClick={() => {handleActivateStreaming(streaming)}}>Executar</Button>
												</Col>
											</Row>
										</div>))}
                                        {!loadingContracts && !contractSelected?.streamings?.length && contractSelected?.playhub && (<Row>
                                                <Col md={8} sm={8} xs={8}>
                                                    <p className="mb-1"><b>Portal do Assinante</b></p>
                                                    <p className="color-gray">Acesse o portal do assinante e selecione o seu streaming</p>
                                                </Col>
                                                <Col md={4} sm={4} xs={4} className="align-self-center text-center d-grid p-2">
                                                    <Button
                                                        variant="light"
                                                        onClick={() => {
                                                            window.open("https://www.portaldoassinante.com/netcomet/login", "_blank");
                                                        }}
                                                    >
                                                        Acessar
                                                    </Button>
                                                </Col>
                                        </Row>)}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>)}
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader
									variant={invoiceHeader}
								>
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">local_atm</span>
										Faturas
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingContracts && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{!contractSelected && !loadingContracts && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhum contrato selecionado</p>
										</div>
										}
										{openInvoice?.quantidade_em_aberto === 0 && !loadingContracts && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhuma fatura encontrada</p>
										</div>
										}
										{!loadingContracts && contractSelected && openInvoice?.quantidade_em_aberto !== 0 && <>
											<Col md={10} sm={10} xs={10}>
												<p><b>Quantidade em aberto: </b>{openInvoice?.quantidade_em_aberto}</p>
												<p><b>Data de vencimento mais antiga: </b>{formatDate(openInvoice?.data_vencimento_mais_antiga)}</p>
												<p><b>Status mais antiga: </b>{openInvoice?.status_mais_antiga.toUpperCase()}</p>
												<p><b>Valor mais antiga: </b> R$ {openInvoice?.valor_mais_antiga}</p>
											</Col>
											{contractSelected?.status !== 'Pré-Contrato' && <Col md={2} sm={2} xs={2} className="align-self-center text-center">
												<Link to='/boletos' className="d-flex justify-content-end">
													<span className="title-icon material-icons d-flex align-items-center m-0 color-dark-gray fs-1">keyboard_arrow_right</span>
												</Link>
											</Col>}
										</>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader
									variant={contractHeader}
								>
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">menu_book</span>
										Contrato
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{loadingContracts && <div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
										}
										{((!contractSelected && !loadingContracts) || contracts?.length === 0) && <div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhum contrato selecionado</p>
										</div>
										}
										{!loadingContracts && contractSelected && <>
											<Col md={10} sm={10} xs={10}>
												<p><b>Plano: </b>{contractSelected?.plano}</p>
												<p><b>Status: </b>{contractSelected?.status}</p>
											</Col>
											{contractSelected?.status !== 'Pré-Contrato' && <Col md={2} sm={2} xs={2} className="align-self-center text-center">
												<Link to='/contrato' className="d-flex justify-content-end">
													<span className="title-icon material-icons d-flex align-items-center m-0 color-dark-gray fs-1">keyboard_arrow_right</span>
												</Link>
											</Col>}
										</>
										}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant={connectionHeader}>
									<div className="d-flex align-items-center">
										<span className="material-icons title-icon">wifi</span>
										Conexões
									</div>
								</CardHeader>
								<CardBody>
									{loadingContracts && <Row className="d-flex m-0">
										<div className="justify-content-center align-items-center d-flex p-2">
											<Spinner animation="border" role="status"/>
										</div>
									</Row>
									}
									{((!contractSelected && !loadingContracts) || contracts?.length === 0) && <Row className="d-flex m-0">
										<div className="justify-content-center align-items-center d-flex">
											<p className="text-center">Nenhum contrato selecionado</p>
										</div>
									</Row>
									}
									{!loadingContracts && contractSelected && <>
										{connections?.map((connection, idx) => ( <div key={idx}>
												<Row className="d-flex m-0">
													<Col md={10} sm={10} xs={10}>
														<p><b>Velocidade de Download: </b>{connection?.download}</p>
														<p><b>Velocidade de Upload: </b>{connection?.upload}</p>
														<p>
															<b>Tipo de Conexão: </b>
															{connection?.tipo_conexao}
														</p>
														<p><b>Status: </b>{connection?.status}</p>
													</Col>
													{contractSelected?.status !== 'Pré-Contrato' && <Col md={2} sm={2} xs={2} className="align-self-center text-center">
														<Link to={`/conexao/${connection?.id}`} className="d-flex justify-content-end">
															<span className="title-icon material-icons d-flex align-items-center m-0 color-dark-gray fs-1">keyboard_arrow_right</span>
														</Link>
													</Col>}
												</Row>
												{connections.length > 1 && idx !== connections.length-1 ? <Col className='m-3'>
													<hr/>
												</Col> : <></>}
											</div>
										))}
									</>}
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>

			<Modal show={showModalUnblock} onHide={() => {return false}} aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header className="justify-content-center border-bottom-0">
					<Modal.Title id="contained-modal-title-vcenter">
						Informar Pagamento e Desbloquear
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="show-grid">
					<Container>
						{loadingModalUnblock && <div className="justify-content-center align-items-center text-center p-2">
								<Spinner animation="border" role="status"/>
								<p className="mt-4">Executando operação, aguarde um momento</p>
							</div>
						}
						{!loadingModalUnblock && <div>
							<Row>
								<Col md={12}>
									{!unblockResponse && <h6>Está operação irá desbloquear o seu contrato retornando os serviços prestados em
									alguns instantes por um período determinado aguardando o processamento do pagamento,
									caso não aconteça no período determinado o contrato será bloqueado assim como os serviços prestados.
									Após utilizar está operação ela ficará indisponível por 30 dias até que possa ser utilizada novamente</h6>}
									{unblockResponse &&
										<Alert variant={unblockResponseStatus ? 'success' : 'danger'} className="d-flex justify-content-center">
											{unblockResponse}
										</Alert>
									}
								</Col>
							</Row>
							</div>
						}
					</Container>
					</Modal.Body>
					{!loadingModalUnblock &&  <Modal.Footer className="border-top-0">
						<Button variant="light" onClick={() => {unblockResponseReload ? window.location.reload() : setShowModalUnblock(false)}}>Fechar</Button>
								{!unblockResponseReload && <Button variant="primary" onClick={() => handleContractUnblock()}>Desbloquear</Button>}
					</Modal.Footer>
					}
			</Modal>
		</>
	);
}
